import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

const vue = new Vue({ // eslint-disable-line no-new
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue
